// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.
// Typescript is intentionally enabled for this file, since the types are used by pipelines.
// If autogeneration causes a type error, strongly prefer fixing the underlying issue over disabling
// typescript.
// For debugging: the file is generated via scripts/pipelines/generate_frontend/generate_frontend.py

import {FIELD_ORDER_UI_SCHEMA_KEY, StepConfigUISchemaV2} from 'pipelines/generalized-step-config-editor/StepConfigEditorTypes';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';

export enum StaticTemplateId {
  EXPERIMENT_OPTIMIZATION = 'EXPERIMENT_OPTIMIZATION',
  STATIC_TEMPLATE_TEST = 'STATIC_TEMPLATE_TEST'
}

export const STATIC_TEMPLATE_UI_SHAPES: {[k in StaticTemplateId]: {configShape: GetPipelineConfigSpecType<'shape'>; name: string; uiSchema: StepConfigUISchemaV2}} = {
  [StaticTemplateId.EXPERIMENT_OPTIMIZATION]: {
    name: 'Experiment Optimization',
    configShape: {
      kind: 'shape',
      required: true,
      fields: {
'Target column': {
  kind: 'columnReference',
  required: true,
  inputDataName: 'INPUT_0',
  validationOptions: null
},
'Grouping column': {
  kind: 'columnReference',
  required: false,
  inputDataName: 'INPUT_0',
  validationOptions: null
},
'Number of recommendations': {
  kind: 'number',
  required: true
},
      },
    },
    uiSchema: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: ['Target column', 'Grouping column', 'Number of recommendations'],
'Target column': {
  configShapePath: [
    'Target column'
  ],
  displayName: 'Target column'
},
'Grouping column': {
  configShapePath: [
    'Grouping column'
  ],
  displayName: 'Grouping column'
},
'Number of recommendations': {
  configShapePath: [
    'Number of recommendations'
  ],
  displayName: 'Number of recommendations'
},
    },
  },
  [StaticTemplateId.STATIC_TEMPLATE_TEST]: {
    name: 'Static template test',
    configShape: {
      kind: 'shape',
      required: true,
      fields: {
'Aggregation column': {
  kind: 'columnReference',
  required: true,
  inputDataName: 'INPUT_0',
  validationOptions: null
},
      },
    },
    uiSchema: {
      [FIELD_ORDER_UI_SCHEMA_KEY]: ['Aggregation column'],
'Aggregation column': {
  configShapePath: [
    'Aggregation column'
  ],
  displayName: 'Aggregation column'
},
    },
  },
};
